module.exports = __webpack_public_path__ + "assets/images/project/head/Wang_Jianjiahe.jpg?v=f0c14c3e";